import { Component, Host, h, Prop,State } from '@stencil/core';
const fa_script = document.createElement('script');

fa_script.src = "https://kit.fontawesome.com/5ad2be44b5.js";
fa_script.setAttribute("crossorigin", "anonymous");
document.body.appendChild(fa_script);

@Component({
    tag: 'portal-footer',
    styleUrl: 'portal-footer.scss',
    shadow: true,
  })
export class PortalFooter {
      /**
   * The dev env
   */
    @Prop() env?: string = 'PROD';
    @Prop() isMobile: boolean = false;
    @State() showCookies: boolean = false;
    @Prop() bussiness_url='https://www.brighttalk.com/business';
    // private getCdnUrl(): string {
    //     let url = '';
    //     switch(this.env) {
    //         case 'int05':
    //         url = 'https://assets.int05.brighttalk.net';
    //         break;
    //         case 'test01':
    //         url = 'https://assets.test01.brighttalk.net';
    //         break;
    //         case 'stage':
    //             url = 'https://assets.stage.brighttalk.net';
    //             break;
    //         default:
    //         url = 'https://assets.brighttalk.com';
    //     }
    //     return url;
    // }
    async componentWillLoad(){
        this.showCookies=false;
        if(window['__tcfapi']){
            var self = this;
            await window['__tcfapi']('getTCData',2, function(data){
            console.log("on react data.gdprApplies: "  + data.gdprApplies);
                if(data.gdprApplies){
                console.log("gdprApplies");
                self.showCookies=true;
                } else{
                    console.log("gdpr not Applies");
                }

            });
        }    
    }
    render() {
        return (
            <Host>
                <div class="btalk-wrap-footer btalk-sitemain-footer">
                    <footer class="top btalk-top-footer">
                        <div class="btalk-footer-content">
                            <div class="btalk-container max width btalk-widgets-grid">
                                <div class="widget-wrap ">
                                <div class="widget widget_nav_menu">
                                    <h4 class="h-widget">Marketing solutions</h4>
                                    <ul class="menu">
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308415">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+'/platform'}>Overview</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308416">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/solutions/webinars'}>Webinars</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308417">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/solutions/lead-generation'}>Lead generation</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308418">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/solutions/virtual-events'}>Virtual events</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308419 last">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/request-a-demo'}>Request a demo</a>
                                        </li>
                                    </ul>
                                </div>
                                </div>
                                <div class="widget-wrap ">
                                <div class="widget widget_nav_menu">
                                    <h4 class="h-widget">Company</h4>
                                    <ul class="menu">
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308420">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/company/about'}>About</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308421">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/academy/blog'}>Blog</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308422">
                                            <a target="_blank" rel="noopener" href='https://www.techtarget.com/about-us/careers/'>Careers</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308423 last">
                                            <a target="_blank" rel="noopener" href={this.bussiness_url+ '/company/contact'}>Contact</a>
                                        </li>
                                    </ul>
                                </div>
                                </div>
                                <div class="widget-wrap ">
                                <div class="widget widget_nav_menu">
                                    <h4 class="h-widget">Support</h4>
                                    <ul class="menu">
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308425">
                                            <a target="_blank" rel="noopener" href="https://brighttalk.zendesk.com/hc/en-us">Channel owners</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308427">
                                            <a target="_blank" rel="noopener" href="https://brighttalk.zendesk.com/hc/en-us/categories/16081676373015-Presenting">Presenters</a>
                                        </li>
                                        <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308429 last">
                                            <a target="_blank" rel="noopener" href="https://brighttalk.zendesk.com/hc/en-us/categories/16081630288535-Viewers">Viewers</a>
                                        </li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                    <footer class="btalk-colophon bottom btalk-bottom-footer web-comp-2">
                        <div class="btalk-container max width">
                            <div class="wrap">
                                <div class="btalk-colophon-content">
                                <div class="site-footer-colophon">
                                    <p class="site-copyright"> Ⓒ 2023 BrightTALK, a subsidiary of 
                                        <a class="text-link" target="_blank" rel="nofollow" href="https://www.techtarget.com/"> TechTarget, Inc.</a>
                                    </p>
                                    <nav class="bt-footer-nav bt-company-links">
                                        <ul class="foot-nav-items" id='footer-2-ul'>
                                            <li><a href={this.bussiness_url+ '/terms-and-conditions'} rel="nofollow" target="_blank">Legal</a></li>
                                            <li><a href={this.bussiness_url+ '/company/privacy-policy'} rel="nofollow" target="_blank">Privacy policy</a></li>
                                            <li><a href="https://techtarget.zendesk.com/hc/en-us/requests/new?ticket_form_id=4555196024471" rel="nofollow" target="_blank">Do Not Sell or Share My Personal Information</a></li>
                                            <li>
                                                <a

                                                id="gdpr_link "

                                                style={{ "display": this.showCookies==true?'':'none' }}

                                                onClick={() => { window['_sp_'].loadPrivacyManagerModal(678071); }}

                                                href="javascript:void(0);"

                                                >

                                                Cookie Preferences

                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                                </div>
                                <div class="btalk-social-icons">
                                <div class="btalk-social-global">
                                    <a href="https://twitter.com/brighttalk" class="twitter" title="Twitter" target="_blank" rel="”nofollow”">
                                        <svg fill='#f5f5f5' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"/></svg>
                                    </a>
                                    <a href="https://www.linkedin.com/company/brighttalk" class="linkedin" title="LinkedIn" target="_blank" rel="”nofollow”">
                                        <svg fill='#f5f5f5' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>
                                    </a>
                                    <a href="https://www.facebook.com/BrightTALK" class="facebook" title="Facebook" target="_blank" rel="”nofollow”">
                                        <svg fill='#f5f5f5' xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg>
                                    </a>
                                </div>
                                </div>
                                <div id="cmp-banner"></div>
                            </div>
                        </div>
                    </footer>
                    </div>
            </Host>
        );
    }
}
